export default "__VITE_ASSET__Bxk9H0yo__"